module.exports = __webpack_public_path__ + "static/media/sharable.70258d04.svg";